module.exports = __webpack_public_path__ + "static/media/Yes_pad.683bf029.png";